export default {
  apiKey: "AIzaSyBH7BliLVwIve5CgcajdRYukOC3cCXrP3g",
  authDomain: "gitfire-46cda.firebaseapp.com",
  projectId: "gitfire-46cda",
  storageBucket: "gitfire-46cda.appspot.com",
  messagingSenderId: "177804824078",
  appId: "1:177804824078:web:055fe7ccd16e74abe8b65f",
  measurementId: "G-WDFEG464EF",
};
